import { render } from "./PetDoors.vue?vue&type=template&id=21c7e637&scoped=true"
import script from "./PetDoors.vue?vue&type=script&lang=js"
export * from "./PetDoors.vue?vue&type=script&lang=js"

import "./PetDoors.vue?vue&type=style&index=0&id=21c7e637&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c7e637"]])

export default __exports__